import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import update from "immutability-helper";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AWS from "aws-sdk";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import FlavorTabShimmer from "./FlavorTabShimmer";
import { ServiceApi } from "../services/index.service";
import ActiveList from "../components/ActiveList";
import { useSnackbar } from "notistack";
import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import { storeSet } from "../redux/store/storeSlice";
import {
  CUSTARD_CATEGORY,
  FLAVOR_DRIVEN_TREATS,
  HAND_SCOOPED_CUSTARD_CATEGORY,
} from "../utils/constants";
import RecipeGallonOptionsGrid from "./RecipeGallonOptionsGrid";
import RecipeContainerOptionsGrid from "./RecipeContainerOptionsGrid";
import RecipeFlavorCategoryItems from "./RecipeFlavorCategoryItems";
import RecipeFDTCategoryItems from "./RecipeFDTCategoryItems";
import { CloseTwoTone } from "@mui/icons-material";
import { StoreDropdown } from "./shared/StoreDropdown";
import { getSearchResults } from "./FlavorsList";
//Tour imports
import { updateSteps,showTourProgress,runTour, continuousTour } from "../redux/userOnboarding/userOnboardingSlice";
import { RECIPE_PORTAL_TOUR_STEPS } from "../utils/tourConstants";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const getRecipeSignedUrl = (file) => {
  // const fileData = file.replace("'", "");
  return file;
  // const imgPath = file.split("/");
  // const iParams = {
  //   Bucket: process.env.REACT_APP_AWS_BUCKET,
  //   Key: `${imgPath[3]}/${imgPath[4]}`,
  // };
  // var url = s3.getSignedUrl("getObject", iParams);
};
const DigitalRecipePortal = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const serviceapi = new ServiceApi();
  const { storage, userOnboarding } = useSelector((state) => state);
  // handle tour
  const digitalReceipeTourStatus = userOnboarding?.tourStatus?.digitalRecipePortal;
  // handle flavors
  const [loading, setLoading] = React.useState(false);
  const [flavorLoading, setFlavorLoading] = useState(false);
  const [flavors, setFlavors] = React.useState(null);
  // const [filteredFlavors, setFilteredFlavors] = React.useState(null);
  const [flavorSearch, setFlavorSearch] = useState("");
  const [containerOptions, setcontainerOptions] = useState(null);
  const [containersOptionsArray, setContainersOptionsArray] = useState([]);
  const [tempFlavors, setTempFlavors] = useState(null);
  const [store, setStore] = useState(storage?.store || null);
  let tabIndex =  0;
  if(!userOnboarding?.tourStatus?.digitalRecipePortal) {
    tabIndex = 2;
  }
  const [tab, setTab] = useState(tabIndex);

  const [open, setOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState("");
  const [noimage, setNoImage] = useState("");
  const [clearAll, setClearAll] = React.useState(false);
  const [tCount, setTCount] = useState(4);
  const [isDirty, setIsDirty] = useState(false);
  const [width, setWindowWidth] = useState(0);
  const breakPointWidth = 767;

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };


  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {
  //   if(data?.profile){
  //     isFCUAPIResolved = false;
  //     isFCUSAPIResolved = false;
  //     setLoading(true);
  //     getFCusers();
  //     getFCUserStores("all");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data?.profile]);

  React.useEffect(() => {
    setStore(storage?.store);
  }, [storage?.store]);

  React.useEffect(() => {
    if(store?.intStoreID){
      getFlavors(store?.intStoreID);
    }
  }, [store]);


  useEffect(() => {}, [tab]);

  //Tour Hook
  useEffect( () => {
    if(!digitalReceipeTourStatus && flavors?.all_flavors?.length > 0){
      startReceipePortalTour();
    } 
  }, [flavors, digitalReceipeTourStatus]);

  const startReceipePortalTour = () => {
    dispatch(updateSteps(RECIPE_PORTAL_TOUR_STEPS));
    dispatch(showTourProgress());
    dispatch(runTour("digitalRecipePortal"));
  }

  const getFlavors = async () => {
    setFlavorLoading(true);
    // setTab(0);
    const allFlavorsReq = {
      keyword: "",
      activeFlag: true,
      api_version: 2,
      key: "recpie_cards"
    };
    const allFlavorsResponse = await serviceapi?.fetchManageFlavors(allFlavorsReq);

    const req = {
      intStoreID: store?.intStoreID,
      filter: "all",
      api_version: 2,
      key: "recpie_cards"
    };
    const response = await serviceapi?.fetchStoreFlavors(req);
    // if (response.message === "ok") {
    if (response?.available_flavors?.length > 0) {
      const mappedFlavorsData = response?.available_flavors?.filter(category => category?.active)?.map((category) => {
        const product = allFlavorsResponse?.find(c => c.intProductTypeID === category?.intProductTypeID) || { ...category, flavors: [] };
        return ({
          ...product,
          flavors: product?.flavors?.map(flavor => {
            const recent_flavor = response?.recent_flavors?.find(f => (f.intProductTypeID === flavor?.intProductTypeID && f.intFlavorID === flavor?.intFlavorID));
            const isFavorite = response?.favourite_flavors?.find(f => (f.intProductTypeID === flavor?.intProductTypeID && f.intFlavorID === flavor?.intFlavorID));
            return ({
              ...flavor,
              favourite: isFavorite ? true : false,
              is_recent: recent_flavor ? true : false,
              is_display: true // should be handle from master data
            })
          })
        })
      });
      setTempFlavors({ ...response, all_flavors: mappedFlavorsData });
      splitDataObject({ ...response, all_flavors: mappedFlavorsData });
      setIsDirty(false);
    }
    else if (response?.all_flavors?.length > 0) {
      setTempFlavors(response);
      splitDataObject(response);
      setIsDirty(false);
    } else {
      setFlavors(null);
      setFlavorLoading(false);
    }
    // } else {
    //   console.log("API getFlavors error");
    // }
  };

  const generateGroups = (allFlavors) => {
    allFlavors?.map((item, index) => {
      const flavors_main = item?.flavors?.filter(i => i?.is_display);
      if (flavors_main?.length <= 6) {
        const newGrp = createGroups(flavors_main, 1);
        item.newFlavorsList = newGrp;
      } else if (flavors_main?.length > 6 && flavors_main?.length <= 12) {
        const newGrp = createGroups(flavors_main, 2);
        item.newFlavorsList = newGrp;
      } else {
        const newGrp = createGroups(flavors_main, 3);
        item.newFlavorsList = newGrp;
      }
    });
    return allFlavors;
  }

  const splitDataObject = (response) => {
    if (response) {
      //   const storeOptionItems = response?.store_options;
      const storeOptionItems = { QC: true, HC: true, SC: true, DC: true };
      setcontainerOptions(storeOptionItems);
      const arrayItems = Object.keys(storeOptionItems)
        .map((i) => {
          return { name: i, value: storeOptionItems[i] };
        })
        .filter((j) => j.value === true);
      setContainersOptionsArray(arrayItems);
      response.all_flavors = generateGroups(response?.all_flavors);
      // setTCount(
      //   // Object.values(response?.store_options).reduce(
      //   Object.values({ QC: true, HC: true, SC: true, DC: true }).reduce(
      //     (a, item) => a + (item === true ? 1 : 0),
      //     0
      //   )
      // );
    }

    setFlavors(response);

    setFlavorLoading(false);
  };

  const showImagePDF = (val) => {
    if (val && val !== "NA") {
      setSelectedImage(getRecipeSignedUrl(val));
      setOpen(true);
    } else {
      return;
    }
  };

  const handleSellerCheckFromChild = (
    event,
    categoryIndex,
    flavorId,
    seller,
    fid
  ) => {
    let foundIndex = -1;
    let foundItemId = null;

    const flavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === flavorId
    );

    flavors?.all_flavors[categoryIndex].newFlavorsList.map(
      (listItem, index) => {
        const itemIndex = listItem.list.findIndex(
          (item) => item.intFlavorID === flavorId
        );

        if (itemIndex !== -1) {
          foundIndex = index;
          foundItemId = itemIndex;
        }
      }
    );
    const newData = update(flavors, {
      all_flavors: {
        [categoryIndex]: {
          flavors: {
            [flavorIndex]: { [seller]: { $set: event.target.checked } },
          },
          newFlavorsList: {
            [foundIndex]: {
              list: {
                [foundItemId]: { [seller]: { $set: event.target.checked } },
              },
            },
          },
        },
      },
    });
    setFlavors(newData);
    setIsDirty(true);
    if (seller === 'favourite') {
      const req = {
        intStoreID: store?.intStoreID,
        fid,
        intProductTypeID: flavors?.all_flavors[categoryIndex]?.intProductTypeID,
        intFlavorID: flavorId,
        isFavourite: event.target.checked
      };
      updateFavourite(req, newData);
    }
  };
  // handle seller check
  const handleSellerCheck = (
    event,
    categoryIndex,
    subCategoryIndex,
    flavorId,
    seller,
    fid
  ) => {
    let foundIndex = -1;
    let foundItemId = null;
    const flavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === flavorId
    );
    flavors?.all_flavors[categoryIndex].newFlavorsList.map(
      (listItem, index) => {
        const itemIndex = listItem.list.findIndex(
          (item) => item.intFlavorID === flavorId
        );
        if (itemIndex !== -1) {
          foundIndex = index;
          foundItemId = itemIndex;
        }
      }
    );
    // console.log(flavorIndex, ":flavorIndex", categoryIndex);
    const newData = update(flavors, {
      all_flavors: {
        [categoryIndex]: {
          flavors: {
            [flavorIndex]: { [seller]: { $set: event.target.checked } },
          },
          newFlavorsList: {
            [foundIndex]: {
              list: {
                [foundItemId]: { [seller]: { $set: event.target.checked } },
              },
            },
          },
        },
      },
    });
    setFlavors(newData);
    setIsDirty(true);
    if (seller === 'favourite') {
      const req = {
        intStoreID: store?.intStoreID,
        fid,
        intProductTypeID: flavors?.all_flavors[categoryIndex]?.intProductTypeID,
        intFlavorID: flavorId,
        isFavourite: event.target.checked
      };
      updateFavourite(req, newData);
    }
  };
  
  const updateFavourite = async (req, newData) => {
    const response = await serviceapi?.updateStoreFavourite(req);
    enqueueSnackbar(response?.message ? "Favorite updated successfully" : "Failed to update favorite", {
      anchorOrigin: { vertical: "top", horizontal: "right" },
      variant: response?.message ? "success" : "error",
    })
    if (response?.message) {
      setTempFlavors(newData);
    }
  }

  const handleAdminTreatTreatCheck = (
    event,
    categoryIndex,
    subCategoryIndex,
    flavorId,
    seller,
    fid
  ) => {
    console.log(categoryIndex, subCategoryIndex, flavorId, seller);
    const flavorIndex = flavors?.all_flavors[categoryIndex].categories[
      subCategoryIndex
    ].flavors.findIndex((f) => f.intFlavorID === flavorId);
    const newData = update(flavors, {
      all_flavors: {
        [categoryIndex]: {
          categories: {
            [subCategoryIndex]: {
              flavors: {
                [flavorIndex]: { [seller]: { $set: event.target.checked } },
              },
            },
          },
        },
      },
    });
    setFlavors(newData);
    setIsDirty(true);
    if (seller === 'favourite') {
      const req = {
        intStoreID: store?.intStoreID,
        fid,
        intProductTypeID: flavors?.all_flavors[categoryIndex]?.intProductTypeID,
        intFlavorID: flavorId,
        isFavourite: event.target.checked
      };
      updateFavourite(req, newData);
    }
  };

  const handleAllSellerCheck = (event, categoryIndex, flavorId) => {
    window.open("https://www.ritasice.com");
    return false;
  };

  const handleFlavorSearch = (event) => {
    // console.log(event.target.value, "---");
    if (event.target.value !== "") {
      setFlavorSearch(event.target.value);
    } else {
      setFlavorSearch("");
    }
  };

  const createGroups = (arr, numGroups) => {
    const perGroup = Math.ceil(arr?.length / numGroups);
    return (
      new Array(numGroups)
        .fill("")
        //   .map((_, i) => {arr.slice(i * perGroup, (i + 1) * perGroup)});
        .map((_, i) => {
          return {
            start: i * perGroup + 1,
            end:
              (i + 1) * perGroup > arr?.length
                ? arr?.length
                : (i + 1) * perGroup,
            list: arr?.slice(i * perGroup, (i + 1) * perGroup),
          };
        })
    );
  };

  const changeTab = (event, newValue) => {
    // setTabSlcted("");
    // if (event.target.textContent === "Promotions") {
    //   return;
    // } else {
    // }
    setTab(newValue);
  };

  const clearFilters = () => {
    setFlavorSearch("");
    // getFlavors();
  };

  const handleReset = () => {
    // getFlavors();
    splitDataObject(tempFlavors);
    setIsDirty(false);
    setClearAll(false);
  };
  const handleClearAll = () => {
    let allFlavors = { ...flavors };
    const updatedFlavors = flavors.all_flavors?.map((i) => {
      const mainFlavors = i?.flavors.map((j) => {
        return {
          ...j,
          activeFlag: "0",
          web: false,
          dmb: false,
          oo: false,
          dt: false,
          door_dash: false,
          uber_eats: false,
          grubhub: false,
          active_rank: "0",
          favourite: false,
        };
      });
      return { ...i, flavors: mainFlavors };
    });
    allFlavors = { ...flavors, all_flavors: updatedFlavors };
    splitDataObject(allFlavors);
    setIsDirty(false);
  };

  const imageOnLoad = (event) => {
    console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
    if (event.currentTarget.className !== "error") {
      event.currentTarget.className = "success";
      setNoImage("SUCCESS");
    }
  };
  const imageOnError = (event) => {
    event.currentTarget.src = "../assets/images/noimage.jpg";
    event.currentTarget.className = "error";
    setNoImage("FAILURE");
  };

  let AllMainFlavors = flavors?.all_flavors;
  AllMainFlavors = flavors?.all_flavors?.filter(
    (i) => i?.intProductTypeID !== FLAVOR_DRIVEN_TREATS
  );
  const flavorDrivenTreats = flavors?.all_flavors?.find(
    (i) => i?.intProductTypeID === FLAVOR_DRIVEN_TREATS
  );
  
  const flavorsData = flavorSearch?.length > 0 ? getSearchResults(AllMainFlavors, flavorSearch, 'flavors') : AllMainFlavors;
  const AllMainFlavorsData = flavorSearch?.length > 0 ? generateGroups(flavorsData) : AllMainFlavors;

console.log(width)
  return (
    <>
      <div className="py-6 mt-16">
       

        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              {"Recipe Card Portal"}
            </h1>

            {/* <div className="flex justify-end ">
              <StoreDropdown store={store} storeList={storeList} editStoreAccess={editStoreAccess} handleStoreChange={handleStoreChange} />
            </div> */}
          </div>
        </header>
        <main>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading || flavorLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
     
          {flavors?.all_flavors?.length > 0 ? (
            <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
              <div className="px-4 py-8 sm:px-0">
                <div className="rounded-md bg-white shadow-md stickytop ">
                  {/* {!isSDLoading && ( */}
                  <div className="p-4 py-5 sm:flex sm:items-center sm:justify-between">
                    <div className="flex items-center gap-2">
                      <OutlinedInput
                        size="small"
                        autoComplete="off"
                        style={{
                          fontFamily:
                            "'Open Sans', Verdana, sans-serif, FontAwesome",
                        }}
                        // className="bg-white text-xs border rounded border-gray-200"
                        sx={{ height: 32, paddingRight: 0, width: 260 }}
                        id="outlined-controlled"
                        placeholder="&#xF002; search"
                        name="flavorSearch"
                        value={flavorSearch}
                        onChange={handleFlavorSearch}
                        inputProps={{
                          style: {
                            color: "#000",
                            fontSize: "13px",
                          },
                        }}
                        endAdornment={
                          <InputAdornment>
                            <IconButton
                              onClick={clearFilters}
                              sx={{
                                visibility: flavorSearch ? "visible" : "hidden",
                              }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>

                    {/* <div className="mt-3 flex sm:mt-0 sm:ml-4">
                      <button
                        type="button"
                        onClick={() => updateFlavors()}
                        disabled={
                          flavorSearch !== "" ||
                          flavors?.all_flavors?.length === 0
                        }
                        className={`ml-3 inline-flex items-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 ${
                          flavorSearch !== "" ||
                          flavors?.all_flavors?.length === 0
                            ? "cursor-not-allowed"
                            : "cursor-pointer"
                        } `}
                      >
                        Update Favorites
                      </button>
                    </div> */}
                  </div>

                  <div className="w-full h-full lg:w-5/5 border-b lg:border-b-0 lg:border-r pb-2 category-recipes-tour-selector">
                    <Tabs
                      // orientation="vertical"
                      value={tab}
                      onChange={changeTab}
                      textColor="primary"
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="Todays Flavors"
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: "#D97D54",
                        },
                      }}
                      classes={{ scroller: userOnboarding?.tourStatus?.digitalRecipePortal ? "" : "!overflow-hidden" }}
                    >
                      {AllMainFlavors && (
                        <Tab
                          className="text-primary text-right recent-flavors-tour-selector"
                          key="recent"
                          sx={{ alignSelf: "end" }}
                          label="Recents"
                          tabIndex={0}
                          value={0}
                        ></Tab>
                      )}
                      {AllMainFlavors && (
                        <Tab
                          className="text-primary text-right favorites-tab-tour-selector"
                          key="favourites"
                          sx={{ alignSelf: "end" }}
                          label="Favorites"
                          tabIndex={1}
                          value={1}
                        />
                      )}

                      {AllMainFlavors?.map((category, i) => (
                        <Tab
                          className={`text-primary text-right ${category.product_type_name === 'Italian Ice' ? 'italian-ice-recipe-tour-selector' : category.product_type_name === 'Custard' ? 'custard-recipe-tour-selector' : ''}`}
                          key={category.intProductTypeID}
                          sx={{ alignSelf: "end" }}
                          tabIndex={i + 2}
                          value={i + 2}
                          label={`${category.product_type_name} (${
                            category?.flavors?.filter((flv) =>
                              flv.flavor_name
                                .toLowerCase()
                                .includes(flavorSearch.toLowerCase()) && flv?.is_display
                            ).length
                          })`}
                        />
                      ))}
                      {flavorDrivenTreats && (
                        <Tab
                          className="text-primary text-right"
                          key={FLAVOR_DRIVEN_TREATS}
                          sx={{ alignSelf: "end" }}
                          label={flavorDrivenTreats?.product_type_name}
                          tabIndex={flavors?.all_flavors?.length + 2}
                          value={flavors?.all_flavors?.length + 2}
                        ></Tab>
                      )}
                    </Tabs>
                    {/* )} */}
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row w-full items-start">
                  <div className="w-full lg:w-5/5 bg-white-100">
                    {tab === 0 && (
                      <TabPanel value={tab} index={0} key={"recent"}>
                        <ActiveList
                          store={store}
                          flavors={flavorsData}
                          tCount={tCount}
                          tab={0}
                          flavorLoading={flavorLoading}
                          containerOptions={containerOptions}
                          containersOptionsArray={containersOptionsArray}
                          handleSellerCheckFromChild={
                            handleSellerCheckFromChild
                          }
                          handleAdminTreatTreatCheck={
                            handleAdminTreatTreatCheck
                          }
                          handleAllSellerCheck={handleAllSellerCheck}
                          showImagePDF={showImagePDF}
                        />
                      </TabPanel>
                    )}
                    {tab === 1 && (
                      <TabPanel value={tab} index={1} key={"favorites"}>
                        <ActiveList
                          store={store}
                          flavors={flavorsData}
                          tCount={tCount}
                          tab={tab}
                          flavorLoading={flavorLoading}
                          containerOptions={containerOptions}
                          containersOptionsArray={containersOptionsArray}
                          handleSellerCheckFromChild={
                            handleSellerCheckFromChild
                          }
                          handleAdminTreatTreatCheck={
                            handleAdminTreatTreatCheck
                          }
                          handleAllSellerCheck={handleAllSellerCheck}
                          showImagePDF={showImagePDF}
                        />
                      </TabPanel>
                    )}
                    {tab > 1 &&
                      tab < flavors?.all_flavors?.length + 2 &&
                      AllMainFlavorsData?.map((category, categoryIndex) => (
                        <TabPanel
                          key={category.intProductTypeID}
                          value={tab}
                          index={categoryIndex + 2}
                        >
                          {flavorLoading ? (
                            <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                            </div>
                          ) : (
                            <div className="">
                              {category?.intProductTypeID ===
                                HAND_SCOOPED_CUSTARD_CATEGORY ||
                              category?.intProductTypeID ===
                                CUSTARD_CATEGORY ? (
                                <RecipeGallonOptionsGrid />
                              ) : (
                                <RecipeContainerOptionsGrid />
                              )}
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-5">
                                {category?.newFlavorsList?.map(
                                  (scategory, scategoryIndex) => (
                                    <RecipeFlavorCategoryItems
                                      tCount={tCount}
                                      category={category}
                                      categoryIndex={categoryIndex}
                                      scategory={scategory}
                                      scategoryIndex={scategoryIndex}
                                      containerOptions={containerOptions}
                                      showImagePDF={showImagePDF}
                                      handleSellerCheck={handleSellerCheck}
                                      flavors={flavors}
                                    />
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </TabPanel>
                      ))}
                    {tab === flavors?.all_flavors?.length + 2 &&
                      flavorDrivenTreats && (
                        <TabPanel
                          key={flavorDrivenTreats.intProductTypeID}
                          value={tab}
                          index={flavors?.all_flavors?.length + 2}
                        >
                          {flavorLoading ? (
                            <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                              <FlavorTabShimmer />
                            </div>
                          ) : (
                            <div className="">
                              <RecipeContainerOptionsGrid />
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-5">
                                {flavorDrivenTreats?.categories?.map(
                                  (scategory, scategoryIndex) => (
                                    <RecipeFDTCategoryItems
                                      tCount={tCount}
                                      scategory={scategory}
                                      scategoryIndex={scategoryIndex}
                                      containersOptionsArray={
                                        containersOptionsArray
                                      }
                                      containerOptions={containerOptions}
                                      showImagePDF={showImagePDF}
                                      handleAdminTreatTreatCheck={
                                        handleAdminTreatTreatCheck
                                      }
                                      flavors={flavors}
                                    />
                                  )
                                )}
                              </div>
                            </div>
                          )}
                        </TabPanel>
                      )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="mx-6 my-3 sm:px-0">
              {!store || store === "" ? (
                <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                  Please select a store
                </div>
              ) : (<>
                {!flavorLoading && flavorSearch==="" && <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                  Recipe card are not available for this store.
                </div>}
              </>
              )}
            </div>
          )}
        </main>
      </div>
      {/* <Dialog
        open={openDialog}
        onClose={handleConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to clear all flavors selection"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            After confirm, the changes cannot be reverted.Please
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialog}>Cancel</Button>
          <Button onClick={updateFlavors} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog> */}
      <Dialog
          open={open}
          fullScreen={width < breakPointWidth ? true : false}
          // fullWidth
          // maxWidth="sm"
          // scroll="paper"
          onClose={handleClose}
          PaperProps={
            width > breakPointWidth ? {
            style: {
              minWidth: "60%",
              maxWidth: "65%",
              minHeight: "55%",
              maxHeight: "100%",
            },
          }:{}
        }
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{paddingTop:'0px',paddingBottom:'0px'}}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>Recipe Card</div>
              <Button
                onClick={handleClose}
                style={{ borderColor: "slateblue" }}
              >
                <CloseTwoTone />
              </Button>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <img
              style={{ width: "100%" }}
              src={selectedImage}
              onLoad={imageOnLoad}
              onError={imageOnError}
              alt="recipe"
            />
          </DialogContent>
        </Dialog>
    </>
  );
};

export default DigitalRecipePortal;
